export const withNamespace = (Component, components) => {
  Object.assign(Component, components);
  return Component;
};
